// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 968) return "static/chunks/968-1d8bc2837d659b2e.js";
	if (chunkId === 1062) return "static/chunks/1062-3970b494839f1e89.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6068":"47bfb2835eef9a74","7572":"fb6e48ba62a9a853"}[chunkId] + ".js";
};